module.exports = __webpack_public_path__ + "static/media/365Media_Islanda.fd28f054.png";